module.exports = __webpack_public_path__ + "img/10.de28705a.jpg";